import { observer } from 'mobx-react-lite';

/**
 * 전략 생성 시 초보자를 위한 팁 표시
 * 종목이 없을 때만 표시됨
 */
const BeginnerTip = observer(() => {
    return (
        <div className="bg-info/10 text-info mb-3 rounded-lg p-3 text-sm leading-relaxed">
            💡 <strong>처음 만들어보시나요?</strong>
            <div className="text-info/90 mt-1.5 text-sm">
                • 오를 것 같은 종목 2-3개를 골라보세요
                <br />
                • 검색이나 AI 추천으로 쉽게 추가할 수 있어요
                <br />
                • 비중은 비슷하게 나눠도 괜찮아요
                <br />• 언제든 바꿀 수 있으니 부담 없이 시작해보세요
            </div>
        </div>
    );
});

export default BeginnerTip;
